import { Component, DestroyRef, effect, inject, Input, untracked } from '@angular/core';
import { BucketService, FolderNode } from 'src/app/services/bucket/bucket.service';
import { BucketStoreService } from '../../bucket-store.service';

@Component({
  selector: 'app-breadcrumb-folder-tree',
  standalone: false,

  templateUrl: './breadcrumb-folder-tree.component.html',
  styleUrl: './breadcrumb-folder-tree.component.scss',
})
export class BreadcrumbFolderTreeComponent {
  @Input() useInDialog: boolean = false;
  @Input() lastFolderDynamic: string | undefined = undefined;
  @Input() isDialogCreazione: boolean = false;

  private readonly _store = inject(BucketStoreService);
  private readonly destroyRef = inject(DestroyRef);

  breadcrumbPath: FolderNode[] = [];
  get listaFolders() {
    if (this._store.tree()) {
      return this._store.tree()[0]?.folders;
    }
    return [];
  }

  get folderSelezionato() {
    return this._store.selectedFolder();
  }

  /* Intercetto i cambiamenti  e selectedFolder */
  effectBreadcrumb = effect(() => {
    const listaFolders = untracked(() => this._store.tree()[0]?.folders); // non intercetto il cambiamento
    const folderSelezionato = this._store.selectedFolder();

    if (listaFolders?.length > 0 && folderSelezionato) {
      this.breadcrumbPath = this._findPathInRoots(listaFolders, folderSelezionato.id) ?? [];
    } else {
      this.breadcrumbPath = [];
    }
  });

  maxVisibleBreadcrumbs = 3;
  /**
   * Mostro solamente 3 directory
   */
  get visibleBreadcrumbs(): any {
    const total = this.breadcrumbPath.length;
    if (total <= this.maxVisibleBreadcrumbs) {
      return this.breadcrumbPath;
    }
    return [
      { name: '...', isEllipsis: true },
      ...this.breadcrumbPath.slice(total - this.maxVisibleBreadcrumbs),
    ];
  }

  constructor(private readonly _bucketService: BucketService) {}

  private _findPathInRoots(
    listaFolders: FolderNode[],
    folderSelezionatoId: string,
  ): FolderNode[] | null {
    for (const folder of listaFolders) {
      const found = this.findPath(folder, folderSelezionatoId, []);
      if (found) {
        return found;
      }
    }
    return null;
  }

  private findPath(
    folder: FolderNode,
    folderSelezionatoId: string,
    currentPath: FolderNode[],
  ): FolderNode[] | null {
    const newPath = [...currentPath, folder];

    if (folder.id === folderSelezionatoId) {
      return newPath;
    }

    if (folder.folders) {
      for (const child of folder.folders) {
        const found = this.findPath(child, folderSelezionatoId, newPath);
        if (found) {
          return found;
        }
      }
    }

    return null;
  }

  onBreadcrumbClick(folder: FolderNode) {
    this._store.setSelectedFolder(folder);
  }
}
